export default __webpack_public_path__ + "static/media/f8cfdf2c429cc850e5fc6d816c93715a.22a291f0.png";